import { filterList, IFilter } from 'affiny-core/modules/matches/utils';
import { IRootState } from 'affiny-core/modules/state';
import get from 'lodash/get';

export const selectAffinyMatchList = (state: IRootState) =>
  get(state, 'matches.affiny.list');

export const selectAffinyOriginalMatchList = (state: IRootState) =>
  state.matches.affiny.originalList;

export const selectAffinyAdditionalMatchList = (state: IRootState) =>
  state.matches.affiny.additionalList;

export const selectScoreMatchList = (state: IRootState) => {
  return state.matches.sort.list;
};

export const selectSortMatchListType = (state: IRootState) =>
  state.matches.sort.sortType;

export const selectCurrentSort = (state: IRootState) => {
  const currentSortType = selectSortMatchListType(state);

  return filterList.filter(
    sortItem => sortItem.sortType === currentSortType
  )[0] as IFilter;
};

export const selectFormattedSortList = (state: IRootState): IFilter[] => {
  const currentSortType = selectSortMatchListType(state);

  // we voluntarily remove the sortType key because it is unnecessary in the filterModal
  // this way the FilterModal component is not coupled with the sortList component
  return filterList.map(({ sortType, ...restOfItem }) => ({
    ...restOfItem,
    isSelected: sortType === currentSortType,
  }));
};

export const selectSortMatchListLength = (state: IRootState) =>
  state.matches.sort.list.length;

export const selectMatchListTotal = (state: IRootState): number | undefined =>
  get(state, 'matches.sort.meta.total');

export const selectMatchListCurrentPage = (state: IRootState): number =>
  get(state, 'matches.sort.meta.currentPage');
